import React from 'react';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { volumes } from '../../data/landing';
import { CtaButton } from '../CtaButton';
import { SectionHeading } from '../SectionHeading';
export function Volumes() {
  return <section className="w-full bg-canvas px-5 py-16 md:py-24" data-id="element-330" data-mp="2wzp38xfj17ge">
      <div className="mx-auto max-w-4xl" data-id="element-331" data-mp="2t0g5zila2rg3">
        <SectionHeading title={<>
              What you’ll find inside <span className="italic text-sky" data-id="element-333" data-mp="2o269n4nthksw">Ortho Treatment Map™</span>
            </>} sub="Six volumes that follow the exact order you plan a case — from first look to final roadmap." data-id="element-332" data-mp="2szesl7gshsv7" />

        <ol className="mt-12 space-y-5" data-id="element-334" data-mp="2e8pi67b5khse">
          {volumes.map(v => <li key={v.numeral} className="overflow-hidden rounded-3xl bg-white ring-1 ring-navy/10" data-id="element-335" data-mp="29da69kwpgvym">
              <div className="flex items-center gap-4 bg-navy px-6 py-5" data-id="element-336" data-mp="259kll6j5iyiv">
                <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-sky font-serif text-2xl font-black text-white" data-id="element-337" data-mp="20c28d3y3px52">
                  {v.numeral}
                </span>
                <div data-id="element-338" data-mp="37xe6zq20wzev">
                  <p className="text-xs font-bold uppercase tracking-wider text-sky-light" data-id="element-339" data-mp="37xxdmam841dl">Volume {v.numeral}</p>
                  <h3 className="mt-0.5 font-serif text-xl font-bold leading-snug text-white md:text-2xl" data-id="element-340" data-mp="2u2uzx1b4x7q8">{v.title}</h3>
                </div>
              </div>
              <div className="px-6 py-6" data-id="element-341" data-mp="3lx6uzdm611j5">
                {v.lead.map(p => <p key={p} className="mb-3 text-[17px] leading-relaxed text-navy" data-id="element-342" data-mp="3qvqgjcwukbaz">
                    {p}
                  </p>)}
                {v.flow && <ol className="my-4 flex flex-wrap items-center gap-2" data-id="element-343" data-mp="3huii8uubzagw">
                    {v.flow.map((step, i) => <li key={step} className="flex items-center gap-2" data-id="element-344" data-mp="21g0u9aiz8cwt" data-mpi={i}>
                        <span className="rounded-lg bg-sky-pale px-3 py-1.5 text-sm font-bold text-navy-700" data-id="element-345" data-mp="26fdgpu5xrhyv">{step}</span>
                        {i < (v.flow?.length ?? 0) - 1 && <ArrowRightIcon className="h-4 w-4 text-sky" aria-hidden="true" data-id="element-346" data-mp="byn5nwdlaemm" />}
                      </li>)}
                  </ol>}
                {v.bullets && <ul className="my-4 grid gap-2.5 sm:grid-cols-2" data-id="element-347" data-mp="27it13bdz5uy">
                    {v.bullets.map(b => <li key={b} className="flex items-start gap-2.5 text-[16px] font-medium text-navy" data-id="element-348" data-mp="3ubbiqokmvgfb">
                        <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-cta" aria-hidden="true" data-id="element-349" data-mp="3keyewxvdjm6u" />
                        {b}
                      </li>)}
                  </ul>}
                {v.closing && <p className="text-[17px] font-semibold leading-relaxed text-navy-700" data-id="element-350" data-mp="3bf1whdzkvjk8">{v.closing}</p>}
              </div>
            </li>)}
        </ol>

        <div className="mt-12" data-id="element-351" data-mp="1dm611f4i6y8r">
          <CtaButton label="I want all 6 volumes" data-id="element-352" data-mp="19mdneo0961wj" />
        </div>
      </div>
    </section>;
}